// extracted by mini-css-extract-plugin
export default {"VideoContainer":"rOTJANhwKmcEQhZlol75","Overlay":"wlJ5VG0tzcseJXeJIp82"};